import { render, staticRenderFns } from "./Soporte_component.vue?vue&type=template&id=1fa3c5d6&scoped=true"
import script from "./Soporte_component.vue?vue&type=script&lang=js"
export * from "./Soporte_component.vue?vue&type=script&lang=js"
import style0 from "./Soporte_component.vue?vue&type=style&index=0&id=1fa3c5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3c5d6",
  null
  
)

export default component.exports